/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { FieldType } from './FieldType.js';
import {
    FieldTypeFromJSON,
    FieldTypeFromJSONTyped,
    FieldTypeToJSON,
} from './FieldType.js';
import type { SearchResultDisplayType } from './SearchResultDisplayType.js';
import {
    SearchResultDisplayTypeFromJSON,
    SearchResultDisplayTypeFromJSONTyped,
    SearchResultDisplayTypeToJSON,
} from './SearchResultDisplayType.js';

/**
 * 
 * @export
 * @interface Field
 */
export interface Field {
    /**
     * 
     * @type {number}
     * @memberof Field
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Field
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof Field
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Field
     */
    placeholder?: string;
    /**
     * 
     * @type {FieldType}
     * @memberof Field
     */
    type?: FieldType;
    /**
     * 
     * @type {Array<string>}
     * @memberof Field
     */
    options?: Array<string>;
    /**
     * 
     * @type {SearchResultDisplayType}
     * @memberof Field
     */
    searchResultDisplayType?: SearchResultDisplayType;
    /**
     * 
     * @type {boolean}
     * @memberof Field
     */
    isHidden?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Field
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof Field
     */
    validationPattern?: string;
}

/**
 * Check if a given object implements the Field interface.
 */
export function instanceOfField(value: object): boolean {
    return true;
}

export function FieldFromJSON(json: any): Field {
    return FieldFromJSONTyped(json, false);
}

export function FieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): Field {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'name': json['name'] == null ? undefined : json['name'],
        'placeholder': json['placeholder'] == null ? undefined : json['placeholder'],
        'type': json['type'] == null ? undefined : FieldTypeFromJSON(json['type']),
        'options': json['options'] == null ? undefined : json['options'],
        'searchResultDisplayType': json['searchResultDisplayType'] == null ? undefined : SearchResultDisplayTypeFromJSON(json['searchResultDisplayType']),
        'isHidden': json['isHidden'] == null ? undefined : json['isHidden'],
        'order': json['order'] == null ? undefined : json['order'],
        'validationPattern': json['validationPattern'] == null ? undefined : json['validationPattern'],
    };
}

export function FieldToJSON(value?: Field | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'slug': value['slug'],
        'name': value['name'],
        'placeholder': value['placeholder'],
        'type': FieldTypeToJSON(value['type']),
        'options': value['options'],
        'searchResultDisplayType': SearchResultDisplayTypeToJSON(value['searchResultDisplayType']),
        'isHidden': value['isHidden'],
        'order': value['order'],
        'validationPattern': value['validationPattern'],
    };
}

